







































































import { Component } from "vue-property-decorator";
import {
  DealAttachmentJson,
  CustomerContactInfo,
} from "@/models/filebunker/deal";
import { AttachmentViewModel } from "@/models/fixedops/attachment";
import VueUploadComponent from "vue-upload-component";
import { FileHelper } from "@/helper/file.helper";
import { Utils } from "@/helper/utils";
import { FileViewModel, NewFaxViewModel } from "@/models/telephony/message";
import { FaxLine } from "@/models/admin/store";
import { VHeaders, VAction } from "@/models/pagedlistmodel";
import {
  ConversationTypes
} from "@/enums/enums";

import { Base } from "@/components/common/base";
import { IDialogOption } from "@/models/dialog";
import { VFields } from "@/models/v-fields";
import { FileHelper as _file } from "@/helper/file.helper";
import { attachmentTypeService } from "@/shared";
import {
  dealService,
  messageService,
  storeService,
  attachmentService,
  customerService,
} from "@/shared";
import { FileSize } from "@/helper/enum";

@Component({
  props: ["methodName", "progress"],
  computed: {
    methodtoCall: {
      get() {
        return this.$props.methodName;
      },
    },
    pages() {
      return this.pagedDeals.totalPages;
    },
  },
  components: {
    Grid: () => import("@/components/common/app.grid.vue"),
    EmailAttachment: () => import("@/components/common/email.attachment.vue"),
    AppDialog: () => import("@/components/common/app.dialog.vue"),
    FileUpload: VueUploadComponent,
  },
})
export default class DealAttachmentsPage extends Base {
  public window: any = window;
  public loading: boolean = false;
  public attachments: DealAttachmentJson[] = [];
  public customerInfo: CustomerContactInfo = {};
  public emailUrl: string = "";
  public customerKey: string = "";
  public dealId: number = 0;
  public dealNo: string = "";
  public showEmailDialog: boolean = false;
  public isPublic: boolean = false;
  public attachmentTypes: any = [];
  public selectedAttachmentType: number = null;
  public attachmentId: string = "";
  public requestProgress: boolean = false;
  public customerLoading: boolean = false;
  public form: any = {};
  public formFields: Array<VFields<any>> = [];

  // Dialog
  public editDialog: IDialogOption = {
    width: 500,
    title: this.$parent.$t("dealAttachment.editDialog.title") as string,
    model: false,
    loading: false,
    action: {
      color: "success",
      icon: "fas fa-edit",
      text: this.$parent.$t("dealAttachment.editDialog.lblUpdate") as string,
    },
    onAction: (): void => {
      this.updateAttachmentType();
    },
  };
  public commentDialog: IDialogOption = {
    width: 500,
    title: " ",
    model: false,
    loading: false,
    action: {
      color: "success",
      icon: "fas fa-check",
      text: this.$parent.$t("dealAttachment.commentDialog.lblSave") as string,
    },
    onAction: (): void => {
      this.updateAttachmentType();
    },
  };
  public showFaxDialog: IDialogOption = {
    width: 500,
    model: false,
    loading: false,
    action: {
      color: "success",
      icon: "fas fa-paper-plane",
      text: this.$parent.$t("dealAttachment.faxDialog.lblSend") as string,
    },
    onAction: (): void => {
      this.sendFax();
    },
  };

  public commentText: string = "";
  public files: any = [];
  public selectedFiles: any = [];
  public dragclass: string = "";
  public dragging: boolean = false;
  public attachmentFiles: FileViewModel[] = [];
  public availableFaxNumbers: FaxLine[] = [];

  public faxToSend: NewFaxViewModel = new NewFaxViewModel(
    ConversationTypes[ConversationTypes.Fax]
  );

  public actions: any[] = [
    {
      type: "button",
      icon: "fas fa-eye",
      title: this.$parent.$t(
        "dealAttachment.gridHeaders.gridAction.open"
      ) as string,
      loading: false,
      action: (model: AttachmentViewModel, action: VAction) => {
        if (model.attachmentTypeName == "Square Reciept") {
          window.open(model.uri, "_blank");
        } else this.openAttachment(model.attachmentId, model.uri, action);
      },
    },
  ];

  public headers: VHeaders[] = [
    {
      text: this.$parent.$t(
        "dealAttachment.gridHeaders.attachmentType"
      ) as string,
      align: "left",
      value: "attachmentTypeName",
    },
    {
      text: this.$parent.$t("dealAttachment.gridHeaders.uploadedAt") as string,
      align: "left",
      value: "createdAt",
      fieldType: "date",
    },
    {
      text: this.$parent.$t("dealAttachment.gridHeaders.comments") as string,
      align: "left",
      value: "comment",
    },
    {
      text: this.$parent.$t("dealAttachment.gridHeaders.isPublic") as string,
      align: "left",
      value: "isPublic",
      fieldType: "switch",
      onChange: (item: any): void => {
        if (item.isPublic) {
          this.togglePublic(item.attachmentId, true);
        } else {
          this.togglePublic(item.attachmentId, false);
        }
      },
      title: (item: any): string => {
        if (item) {
          return item.isPublic ? "Public" : "Not Public";
        }
      },
      disabled: (item: any): boolean => {
        return (
          item.attachmentTypeName === "Deal Document" ||
          item.attachmentTypeName === "File Bunker" || 
          item.attachmentTypeName === "Square Reciept"
        );
      },
    },
    {
      text: this.$parent.$t("dealAttachment.gridHeaders.actions") as string,
      align: "center",
      isNotDataProp: true,
      sortable: false,
    },
  ];

  public beforeDestroy() {
    const buttons = [];
    this.$emit("updateToolBar", buttons);
  }

  public callMethod(methodName): void {
    if (methodName === "backToList") {
      this.backToList();
    }
    if (methodName === "upload") {
      this.UploadAttachment();
    }
    if (methodName !== "") {
      this.$emit("resetMethodName", methodName);
    }
  }
  public updateToolBar(): void {
    const buttons: any = [];
    buttons.push({
      id: "0",
      type: "button",
      title: this.$parent.$t("dealAttachment.btnBackToList") as string,
      disabled: false,
      visible: true,
      class: "btn",
      label: this.$parent.$t("dealAttachment.btnBackToList") as string,
      click: "backToList",
      icon: "fas fa-arrow-left",
    });
    this.$emit("updateToolBar", buttons);
  }
  public mounted(): void {
    // activating tab
    this.$root.$emit("sidebar.layout.vue", "deals");

    // toolbar
    this.updateToolBar();
    this.$watch("methodtoCall", (newVal, oldVal) => {
      if (newVal) {
        this.callMethod(newVal);
      }
    });

    this.formFields = [
      {
        key: "file",
        type: "v-alynk-file-upload",
        required: false,
        templateOptions: {
          counter: 250,
          label: "File",
          validations: "",
          required: false,
          disabled: false,
          multiple: false,
          events: {
            onChange: (files, ref) => {
              const vm = this;
              if (files.length > 0) {
                vm.attachmentFiles = [];
                files.forEach((file) => {
                  FileHelper.getFileBytes(file.file, (base64) => {
                    vm.attachmentFiles.push({
                      base64,
                      extension: file.name.substring(
                        file.file.name.lastIndexOf(".")
                      ),
                      fileName: file.file.name,
                      fileSize: file.file.size,
                    });
                  });
                });
              }
            },
          },
        },
      },
    ];

    this.dealId = Number(this.$route.params.id);
    this.dealNo = this.$route.params.dealNo;
    this.customerKey = this.$route.params.customerkey;

    this.getCustomerInfo(this.customerKey);
    this.getAttachments(this.dealNo);
    this.getAttachmentTypes();
    this.getAvailableFaxNumbers();
  }

  public async getAttachments(dealNo: string): Promise<void> {
    try {
      this.loading = true;
      this.attachments = [];
      const attachments = await dealService.getAttachmentsAsync(
        this.dealNo,
        true
      );
      this.attachments = attachments.results;
    } catch (e) {
      this.showAlert(false, this.$t("dealAttachment.alertGetAttachment"));
    } finally {
      this.loading = false;
    }
  }

  public async getCustomerInfo(customerKey): Promise<void> {
    try {
      this.customerLoading = true;
      const customerInfo = await customerService.getCustomerInfoAsync(
        customerKey
      );
      this.customerInfo = customerInfo;
      this.customerInfo.to = [];
      this.customerInfo.to.push(
        this.customerInfo.email1 || this.customerInfo.email2
      );
      this.customerInfo.cc = [];
    } finally {
      this.customerLoading = false;
    }
  }

  public generateEmail(model: AttachmentViewModel): void {
    this.emailUrl = `${Utils.API_BASE_URL}/deals/attachment/${model.attachmentId}/sendmail`;
    this.showEmailDialog = true;
  }

  public async getAttachmentTypes(): Promise<void> {
    const attachmentTypes = await attachmentTypeService.getAttachmentTypes();
    this.attachmentTypes = attachmentTypes.results;
  }

  public async getAvailableFaxNumbers(): Promise<void> {
    const faxLines = await storeService.getFaxLines();
    this.availableFaxNumbers = faxLines.results;
  }

  public backToList() {
    if (history.state && history.length > 1) {
      this.$router.back();
    } else {
      this.$router.push({ name: "app.deals" });
    }
  }

  public async openAttachment(
    attachmentId: string,
    uri: string,
    action: VAction
  ): Promise<void> {
    try {
      attachmentService.openAttachment(attachmentId);
    } finally {
      // action.loading = false;
      // this.requestProgress = false;
    }
  }

  public hideDialog(): void {
    this.showEmailDialog = false;
  }

  public showEditDialog(attachmentId: string): void {
    this.editDialog.model = true;
    this.attachmentId = attachmentId;
    this.commentText = "";
  }

  public showCommentDialog(attachmentId: string): void {
    this.selectedAttachmentType = null;
    this.commentText = "";
    this.commentDialog.model = true;
    this.attachmentId = attachmentId;
    const data = this.attachments.filter((item) => {
      if (item.attachmentId === attachmentId) {
        return item;
      }
    });
    if (data.length > 0) {
      this.commentText = data[0].comment;
    }

    if (this.commentText !== "" && this.commentText != null) {
      this.commentDialog.title = this.$parent.$t(
        "dealAttachment.commentDialog.editTitle"
      ) as string;
    } else {
      this.commentDialog.title = this.$parent.$t(
        "dealAttachment.commentDialog.addTitle"
      ) as string;
    }
  }

  public async updateAttachmentType(): Promise<void> {
    try {
      this.commentDialog.loading = true;
      this.editDialog.loading = true;
      await dealService.updateAttachmentAsync(
        this.attachmentId,
        this.selectedAttachmentType,
        this.commentText
      );
      this.getAttachments(this.dealNo);
    } finally {
      this.commentDialog.loading = false;
      this.editDialog.loading = false;
      this.editDialog.model = false;
      this.commentDialog.model = false;
    }
  }

  public async UploadAttachment(): Promise<void> {
    if (this.attachmentFiles.length > 0) {
      try {
        this.requestProgress = true;
        var isWebUpload = true;
        this.$emit("update:progress", this.requestProgress);
        await dealService.uploadFileAsync(
          this.dealId,
          this.isPublic,
          isWebUpload,
          this.attachmentFiles
        );
        this.attachmentFiles = [];
        this.selectedFiles = "";
        this.files = [];
        this.getAttachments(this.dealNo);
      } finally {
        this.requestProgress = false;
        this.$emit("update:progress", this.requestProgress);
      }
    }
  }

  public selectFile() {
    const element = this.$refs.upload["$el"].querySelector("input");
    element.click();
  }

  public onChange(fileList) {
    this.selectedFiles = [];
    if (fileList.length > 0) {
      fileList.forEach((file) => {
        const size = file.size / 1024;
        if (size > FileSize.MaxFileSize) {
          this.showAlert(false, this.$t("FileSize.MaxFileSize"));
          return;
        }
        if (file.file) {
          this.selectedFiles.push(file.file);
        }
      });
    }
  }

  public dragOver(element) {
    this.dragging = true;
    this.dragclass = "dragged";
  }

  public dragLeave(event) {
    this.dragging = false;
    this.dragclass = "";
  }

  public async sendFax(): Promise<void> {
    if (!this.faxToSend.from || this.faxToSend.from.trim() === "") {
      this.showAlert(false, this.$t("dealAttachment.alertFillValidSendFax"));
      return;
    }

    if (!this.faxToSend.to || this.faxToSend.to.trim() === "") {
      this.showAlert(false, this.$t("dealAttachment.alertFillValidSendFax"));
      return;
    }
    try {
      this.showFaxDialog.loading = true;
      await messageService.sendFax(this.faxToSend);
      this.showAlert(true, this.$t("dealAttachment.alertFaxSubmitted"));
    } finally {
      this.showFaxDialog.loading = false;
      this.showFaxDialog.model = false;
    }
  }

  public async togglePublic(id: string, status: boolean): Promise<void> {
    try {
      this.showLoader();
      await attachmentService.toggleIsPublicAsync(id, status);
      this.showAlert(true, this.$t("dealAttachment.alertAttachmentUpdated"));
    } finally {
      this.hideLoader();
    }
  }

  private base64ToArrayBuffer(base64) {
    const binaryString = window.atob(base64);
    const binaryLen = binaryString.length;
    const bytes = new Uint8Array(binaryLen);
    for (let i = 0; i < binaryLen; i++) {
      const ascii = binaryString.charCodeAt(i);
      bytes[i] = ascii;
    }
    return bytes;
  }
}
